import styled from 'styled-components';
import { theme } from '../theme';

export const StyledLoaderContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(255, 255, 255, 50%);
  backdrop-filter: blur(4px);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledLoader = styled.div`
  position: absolute;

  div {
    position: absolute;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: ${theme.colors.primaryT2};
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }

  div:nth-child(1) {
    left: 8px;
    animation: loader1 0.6s infinite;
  }

  div:nth-child(2) {
    left: 8px;
    animation: loader2 0.6s infinite;
  }

  div:nth-child(3) {
    left: 32px;
    animation: loader2 0.6s infinite;
  }

  div:nth-child(4) {
    left: 56px;
    animation: loader3 0.6s infinite;
  }

  @keyframes loader1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes loader3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }

  @keyframes loader2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`;

export const StyledTransitionContainer = styled.div`
  .loader-container-transition-enter {
    opacity: 0;
  }

  .loader-container-transition-enter-active {
    opacity: 1;
    transition: opacity 400ms ease-in;
  }

  .loader-container-transition-exit {
    opacity: 1;
  }

  .loader-container-transition-exit-active {
    opacity: 0;
    transition: opacity 400ms ease-out;
  }
`;
